import {
  type Entitlements,
  entitlementsResponseSchema,
} from "@/shared/entitlements/schemas/entitlements.schema";
import { apiCall } from "@/shared/lib/api-call";
import { apiPaths } from "@/shared/lib/api-paths";

/// HTTP boundary for the account's plan gating data. Per webui T3 / FE-SEC6
/// the response is Zod-parsed via the shared `apiCall` helper, even though
/// it's our own backend.
export function getEntitlements(): Promise<Entitlements> {
  return apiCall<Entitlements>(
    apiPaths.me.entitlements(),
    { method: "GET" },
    entitlementsResponseSchema,
  );
}
